import { useContext } from "react";
import { AuthContext } from "../context/AuthContext.js";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { token } = useContext(AuthContext);

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return children;
}